import { useAppDispatch, useAppSelector } from "../redux/redux.hook";
import { useCallback } from "react";
import { getCargoTrackingMetadata, trackOrder } from "./shippingTracking.thunk";
import { clearResult } from "./shippingTracking.slice";
import { isLoading, isSuccess, isError } from "@/app/utils/asyncStatus";
import { TrackOrderRequest } from "./shippingTracking.types";

const useShippingTracking = () => {
  const dispatch = useAppDispatch();
  const { metadata, result } = useAppSelector(
    (store) => store.shippingTracking,
  );

  const fetchMetadata = useCallback(async () => {
    const res = await dispatch(getCargoTrackingMetadata());
    return res.meta.requestStatus === "fulfilled";
  }, [dispatch]);

  const submitTrackOrder = useCallback(
    async (data: TrackOrderRequest) => {
      const res = await dispatch(trackOrder(data));
      return res.meta.requestStatus === "fulfilled";
    },
    [dispatch],
  );

  const resetResult = useCallback(() => {
    dispatch(clearResult());
  }, [dispatch]);

  return {
    metadata: metadata.data,
    isMetadataLoading: isLoading(metadata.status),
    isMetadataSuccess: isSuccess(metadata.status),
    metadataError: metadata.error,

    trackingResult: result.data,
    isResultLoading: isLoading(result.status),
    isResultSuccess: isSuccess(result.status),
    isResultError: isError(result.status),
    resultError: result.error,

    fetchMetadata,
    submitTrackOrder,
    resetResult,
  };
};

export default useShippingTracking;
